import React from 'react';

export const HowItWorks: React.FC = () => {
  const steps = [
    {
      number: "1",
      title: "Saisissez votre numéro de DPE",
      description: "DPEWizard récupère automatiquement vos données auprès de l'ADEME et analyse les incohérences qui faussent les calculs : erreurs de saisie, équipements sous-dimensionnés, éléments manquants. Vous obtenez un score de confiance et la liste des points à corriger avant d'envisager quoi que ce soit."
    },
    {
      number: "2", 
      title: "Répondez aux questions personnalisées",
      description: "Entre 8 et 35 questions selon votre bien : usage du logement, faisabilité des travaux, caractéristiques réelles. L'analyse s'adapte à votre situation — pas à une moyenne nationale."
    },
    {
      number: "3",
      title: "Testez vos hypothèses de travaux en temps réel",
      description: "Composez librement vos combinaisons de travaux. Pour chaque poste, choisissez parmi plusieurs variantes (matériaux, épaisseurs, équipements). Enregistrez vos scénarios, comparez-les, modifiez-les à volonté."
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Titre avec style cohérent */}
        <div className="mb-16">
          <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-3 leading-tight uppercase">
            Simulez l'impact de vos travaux avant de les faire
          </h2>
          <div className="w-12 h-0.5 bg-blue-500 mb-6"></div>
          <p className="text-lg text-gray-600 max-w-4xl">
            La plupart des propriétaires financent des travaux sans savoir ce qu'ils vont vraiment changer. DPEWizard calcule l'impact exact de chaque poste — sur votre classe énergétique, vos factures et votre retour sur investissement — avant que vous ne dépensiez un euro.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-12">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Numéro de l'étape style minimaliste */}
              <div className="flex items-start space-x-4 mb-4">
                <div className={`flex-shrink-0 w-12 h-12 ${index === 2 ? 'bg-green-500' : 'bg-blue-500'} text-white rounded-full flex items-center justify-center text-xl font-bold`}>
                  {step.number}
                </div>
                <div className="pt-2">
                  <h3 className={`text-xl font-bold ${index === 2 ? 'text-green-700' : 'text-gray-900'} mb-3 leading-tight`}>
                    {step.title}
                  </h3>
                </div>
              </div>
              
              <div className="ml-16">
                <p className={`text-base ${index === 2 ? 'text-green-700 font-medium' : 'text-gray-700'} leading-relaxed`}>
                  {step.description}
                </p>
              </div>

              {/* Ligne de connexion (sauf pour le dernier) */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-6 left-full w-12 h-0.5 bg-gray-300 transform -translate-y-1/2"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;